import * as types from './constants';

export const AI_ASSISTANT_MODES = ['sidebar', 'fullscreen', 'floating'];

const normalizeMode = mode => (AI_ASSISTANT_MODES.includes(mode) ? mode : 'sidebar');

const initialState = {
	open: false,
	mode: 'sidebar',
	returnMode: null,
	pendingPrompt: null,
	// Kept for the rest of the session: closing the assistant doesn't give the tokens back
	tokenLimitReached: false
};

const actions = {
	[types.OPEN_AI_ASSISTANT]: (state, { payload }) => ({
		...state,
		open: true,
		mode: payload ? normalizeMode(payload) : state.mode,
		returnMode: payload ? null : state.returnMode
	}),

	[types.CLOSE_AI_ASSISTANT]: state => ({
		...state,
		open: false,
		mode: 'sidebar',
		returnMode: null,
		pendingPrompt: null
	}),

	[types.OPEN_AI_ASSISTANT_WITH_PROMPT]: (state, { payload }) => ({
		...state,
		open: true,
		pendingPrompt: payload || null
	}),

	[types.CLEAR_AI_ASSISTANT_PROMPT]: state => ({
		...state,
		pendingPrompt: null
	}),

	[types.SET_AI_ASSISTANT_TOKEN_LIMIT_REACHED]: state => ({
		...state,
		tokenLimitReached: true
	}),

	[types.SET_AI_ASSISTANT_MODE]: (state, { payload }) => {
		const mode = normalizeMode(payload);

		return {
			...state,
			open: true,
			mode,
			returnMode: mode === 'fullscreen' && state.mode !== 'fullscreen' ? state.mode : null
		};
	}
};

export default (state = initialState, action) => {
	if (actions[action.type]) return actions[action.type](state, action);
	return state;
};
